export class TransactionDetail {
    id: string;
    kioskId: string;
    tenantId: string;
    kioskName: string;
    modified: Date;
    status: number;
    transactionData: TransactionData;
    processResult: string;
    result: TransactionResult;
    refundResult: TransactionResult;
    purchaseDetails: string;
    purchaseDetailsData: PurchaseDetails;
    netAmount: number;
    timeZone: string;
    timeZoneAbbreviation: string;
    transactionTimestampLocal: Date; 
    mobileTimestampUtc: Date;
    mobileTimestampLocal: Date;
    cloudTimestamp: Date;
    cloudTimestampLocal: Date;
    logEntries: Array<string>;
    description: string;
}

export class TransactionData {
    transactionId: string;
    cardHolder: string;
    cardTechnology: number;
    creditCardType: number;
    deviceInfo: DeviceInfo;
    expirationDate: string;
    lastFour: string;
    transactionAmount: number;
    transactionTimestamp: Date;
    hardwareError: boolean;
    hardwareFailureReason: string;
}

export class DeviceInfo {
    ksn: string;
    deviceSerialNumber: string;
}

// These are camel-cased because they're nested inside the corresponding .NET object.
// ReSharper disable InconsistentNaming
export class TransactionResult {
    AuthCode: string;
    AuthorizedAmount: number;
    ProcessorTransactionId: string;
    TransactionMessage: string;
    TransactionStatus: string;
    MagensaTransactionId: string;
    CardId: string;
    RefundResult: string;
}

export class PurchaseDetails {
    Total: number;
    Timestamp: Date;
    PurchaseItems: Array<PurchaseItem>;
    WorkflowName: string;
    DiscountApplied: boolean;
    DiscountPercentage: number;
    Loop: string;
    CampsiteNumber: string;
    NumberOfCampers: number;
}

export class PurchaseItem {
    Total: number;
    Price: number;
    Units: Array<PurchaseUnit>;
    TicketTemplateName: string;
    TicketsPerTransaction: number;
}

export class PurchaseUnit {
    Quantity: number;
    Unit: string;
}
// ReSharper restore InconsistentNaming
